//src/config/platform.ts

export const PLATFORM_URL =
  process.env.NEXT_PUBLIC_PLATFORM_URL || "https://app.maconjob.com";

export const API_URL =
  process.env.NEXT_PUBLIC_API_URL || "https://api.maconjob.com";